module.exports = __webpack_public_path__ + "03_long_brown.a30a937b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_long_brown.png
// module id = ZaPi
// module chunks = 0